import React from 'react';

interface TextareaInputProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
  registerProps?: Record<string, unknown>;
}

export default function TextareaInput({
  hasError,
  registerProps,
  ...props
}: TextareaInputProps) {
  return (
    <textarea
      className="w-full rounded-lg px-4 py-3 text-sm font-sans transition-all duration-150 outline-none resize-y"
      style={{
        border: `1px solid ${hasError ? '#a34f42' : 'var(--input)'}`,
        backgroundColor: 'var(--card)',
        color: 'var(--foreground)',
        fontFamily: 'var(--font-sans)',
        minHeight: '100px',
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = hasError
          ? '#a34f42' :'var(--primary)';
        e.currentTarget.style.boxShadow = `0 0 0 3px ${
          hasError ? 'rgba(163,79,66,0.12)' : 'rgba(155,107,77,0.12)'
        }`;
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = hasError
          ? '#a34f42' :'var(--input)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      {...registerProps}
      {...props}
    />
  );
}